<template>
  <v-dialog persistent v-model="show" width="300px">
    <v-card>
      <v-card-text class="text-xs-center">
        <!-- 今は処理中です、暫くお待ってください。 -->
        {{$t('app.loading')}}
        <v-progress-circular :size="50" class="mt-3 mb-3" color="amber" indeterminate></v-progress-circular>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      loading: 0,
      configs: []
    }
  },
  computed: {
    show() {
      return this.loading > 0
    }
  },
  mounted() {
    this.$bus.$on('startLoading', cfg => {
      this.loading++
      this.configs.push(cfg.url)
    })
    this.$bus.$on('endLoading', cfg => {
      this.loading--
      this.configs.splice(this.configs.findIndex(c => c === cfg.url))
      //this.configs = this.configs.filter(c => c === cfg.url)
    })
  }
}
</script>
